import HttpRequest from "./http_request";

class UserProvider extends HttpRequest {
  async getUserInfo() {
    return this.get("/users/");
  }
}

export default UserProvider;
